import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  { path: '/cost-of-living', name: 'Cost of Living', component: () => import('../views/CostOfLiving.vue') },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/vue',
    name: 'Vue',
    component: () => import('../views/Vue.vue')
  },
  {
    path: '/Things',
    name: 'Things',
    component: () => import('../views/Things.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
